export const ENVIRONMENT_LABELS = {
  'dev.watchid.tudorwatch.com': 'DEV',
  'ci.watchid.tudorwatch.com': 'TEST',
  'pp.watchid.tudorwatch.com': 'PPROD',
};

export const PRODUCTION_HOSTNAME = 'watchid.tudorwatch.com';

export const IS_DEV =
  import.meta.env.DEV && window.location.hostname === 'localhost';

export const IS_PROD = !IS_DEV;

export const SPECIAL_EDITION_DECOR_KEY = '11';
export const CATEGORY_C = 'SRV_GEN_C';

export const SUPPORTED_LOCALES = [
  'ar',
  'de',
  'en',
  'es',
  'fr',
  'he',
  'it',
  'ja',
  'ko',
  'nl',
  'pt',
  'ru',
  'tr',
  'zh-Hans',
  'zh-Hant',
];

export const REQUIRED_TRANSLATION_TYPES = new Set([
  'TDR_BRACELET_TITLE',
  'TDR_CASE_BEZEL',
  'TDR_CASE_CRYSTAL',
  'TDR_CASE_TITLE',
  'TDR_CASE_WATER_RESISTANCE',
  'TDR_CASE_WINDING_CROWN',
  'TDR_DIAL',
  'TDR_MOVEMENT_AUTONOMY',
  'TDR_MOVEMENT_CALIBRE',
]);

export const PLUTON_RMC = new Set([
  'M2542G247NU-0002',
  'M2542G257NU-0002',
  'M2543C1A7NU-0001',
  'M7939A1A0RU-0001',
  'M7939A1A0RU-0002',
  'M7939A1A0RU-0003',
  'M7939G1A0NRU-0001',
  'M7939G1A0NRU-0002',
]);

export const PELAGOS_RMC = new Set(['M2543C1A7NU-0001', 'M2543C1A7NU-0002']);

export const METAS_RMCS = new Set(['M79210CNU-0001', 'M7983/001U-0001']);

export const LIGHT_THEME_DISABLED_RMCS = new Set([
  'M79210CNU-0001',
  'M79210CNU-0002',
]);

export const TUDOR_COLORS = {
  RED: '#BE0100',
  WHITE: '#FFFFFF',
  BLACK: '#000000',
};
